import React from 'react';

import { Chip, CircularProgress } from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import WarningIcon from '@material-ui/icons/Warning';

import { useStyles } from './styles';

interface PimStatusChipProps {
  pimEnabled?: boolean;
  pimGroupId?: string | null;
  loading: boolean;
}

export const PimStatusChip = ({
  pimEnabled,
  pimGroupId,
  loading,
}: PimStatusChipProps) => {
  const classes = useStyles();

  if (!pimEnabled) return null;

  if (loading) {
    return (
      <Chip
        icon={<CircularProgress size={10} style={{ marginLeft: 6 }} />}
        label="Fetching PIM status..."
        size="small"
        variant="outlined"
        className={classes.pimLoadingChip}
      />
    );
  }

  if (pimGroupId) {
    return (
      <Chip
        icon={<VpnKeyIcon className={classes.pimSuccessIcon} />}
        label={
          <span className={classes.pimSuccessLabel}>
            PIM access will be enabled for this tenant
          </span>
        }
        size="small"
        variant="outlined"
        className={classes.pimSuccessChip}
      />
    );
  }

  return (
    <Chip
      icon={<WarningIcon className={classes.pimWarningIcon} />}
      label={
        <span className={classes.pimWarningLabel}>
          PIM access setup not yet complete for this tenant
        </span>
      }
      size="small"
      variant="outlined"
      className={classes.pimWarningChip}
    />
  );
};
